import styled from 'styled-components'

export const StyledRadioButton = styled.div`
  .custom-radio {
    margin-left: -0.5rem;
    margin-bottom: 1.5rem;
    display: inline-block;
    position: relative;
    padding-left: 30px;
    cursor: pointer;
    user-select: none;
  }
  .custom-radio input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    border: 2px solid #ccc;
    background-color: transparent;
    transition: all 0.2s ease;
  }
  .custom-radio input:checked + .checkmark {
    background-color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
    border: none;
  }
  .custom-radio input:checked + .checkmark::after {
    content: '';
    position: absolute;
    top: 4px;
    left: 7px;
    width: 6px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
  .margin-right {
    margin-right: 1rem;
  }
`
